export default "__VITE_ASSET__DS8dvgO8__"